// extracted by mini-css-extract-plugin
export default {"CarCharge":"CarCharge_CarCharge__tBDje","CarCharge__new":"CarCharge_CarCharge__new__EcK8+","CarCharge__table":"CarCharge_CarCharge__table__2AQaF"};